import type { FaireProductEntity } from "../../entity_types/product";

export const p_5cua7k065i: FaireProductEntity = {
  token: "p_5cua7k065i",
  type: "product",
  name: "Moroccan Cone Champagne Glasses",
  brandToken: "b_6xvu4qtx",
  brandName: "Verve Culture",
  imageUrl:
    "https://cdn.faire.com/fastly/db74a2fdf8ceca8f0075ed186422991a2ffd1f24b6e3703a78f94ec2683179be.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9fa7f5acd9209d0cfbcd8b68b8b52476bef00932f3984420ce763b5c59376eec.jpeg",
    "https://cdn.faire.com/fastly/74c93a4bee1e5b4d3cd4d48468c44cae06229c8262b921d1449df83d61e3e7cd.jpeg",
    "https://cdn.faire.com/fastly/b0bf822eaa36f1a203a8df1438e4516f29be06e67ac23bacd11620ccebc69697.jpeg",
    "https://cdn.faire.com/fastly/6079d8a7eda35a0d2a4bf9008f3bc4380b32f0cd88108fc49478afb4b68f258f.jpeg",
    "https://cdn.faire.com/fastly/76dbd8cac803cc0cc72046487e2378d1c18897fdb35b47bfb9e4c1b6ebb03006.jpeg",
    "https://cdn.faire.com/fastly/87dba8ebb1d72a899215e93b841461e6f23762a2ff87ad386e8a3233b6a0e251.jpeg",
    "https://cdn.faire.com/fastly/25847e12d6345bbb15a016afcdc031c7d7ca0ef2091187555f28b086c775ab2f.jpeg",
  ],
  priceDollars: 3.75,
  description:
    "**Packaged in sets of 6** - 24 single glasses in a master\n\nThese beautiful, timeless and hand blown Moroccan champagne glasses are the 21st century way to toast and enjoy.  Each one is unique in style and shape and will compliment that-oh so delicious-bubbly. Works beautifully as a flower vase as well!\n\nMade from recycled wine bottles, these clear sets are a second act for glass that would otherwise be sent to landfills.\n\nThe handblown construction is evident in the bubbles suspended in the glass itself, and the organic forms that the vessels take. Bubbles rule!\n\nGlasses are handblown, variation in size is to be expected.\n\nPackaged in sets of 6 in traditional Moroccan gift packaging.\n\nDimensions: 4.75'' tall / 3.25'' base diameter / 1.5'' top diameter, 6 fl oz capacity",
  tags: [],
  msrpDollars: 7.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-05T16:55:04.456Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
